module.exports = __webpack_public_path__ + "img/rep-angelina.c18585c3.png";